import { createSelector } from 'reselect';
import shuffle from 'lodash/shuffle';
import config from '../configs';

const { maxMerchants } = config;

export const selectTopEarn = state => state.topEarn;
export const selectTopEarnConfig = createSelector(selectTopEarn, topEarn => topEarn.config);
export const selectTopEarnIsLoading = createSelector(selectTopEarn, topEarn => topEarn.isLoading);
export const selectTopEarnIsLoaded = createSelector(selectTopEarn, topEarn => topEarn.isLoaded);
export const selectTopEarnRecords = createSelector(selectTopEarn, topEarn => (
  shuffle(topEarn.merchants).splice(0, maxMerchants)
));
